"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceHistory = exports.LINK = exports.DeviceHistoryClassName = void 0;
const tslib_1 = require("tslib");
const enumerableDecorator_1 = require("../constructs/enumerableDecorator");
const ModelCommon_1 = require("../ModelCommon");
exports.DeviceHistoryClassName = 'DeviceHistory';
var LINK;
(function (LINK) {
    LINK["LINK"] = "Link";
    LINK["UNLINK"] = "Unlink";
})(LINK || (exports.LINK = LINK = {}));
const HISTORY_LIMIT = 15;
/**
 * @class Holds configuration object retrieved from device via downlink request
 * This is a pseudo property ie an instance should have pk as the sk of the device it belongs to,
 * And since it can only have one config, the instances sk should be a concaentation of pk + className
 */
class DeviceHistory extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.DeviceHistoryClassName)
            throw new Error(`Tried to create a ${exports.DeviceHistoryClassName} from a ${ob.type} object!`);
        super(exports.DeviceHistoryClassName, ob);
        this.type = exports.DeviceHistoryClassName;
        this.history = [];
        this.update = (reported) => {
            if (reported) {
                let meta = reported.meta;
                let currentTime = meta.timestamp ?? new Date().getMilliseconds();
                // RSE LEFT AS SHOULD STAY SAME
                // is it first time
                if (!this.initial) {
                    // battery is not in the first
                    this.initial = {
                        RSSI: meta.rssi,
                        SNR: meta.snr,
                        // battery: 1,
                        gateway: meta.nasSourceIp,
                        timestamp: currentTime,
                        NS: meta.networkKey,
                    };
                }
                // RSE LEFT AS SHOULD STAY SAME
                // only set once
                if (meta.battery && this.initial.battery === undefined) {
                    this.initial.battery = meta.battery;
                }
                // RSE: LEFT AS SHOULD STAY SAME
                if (meta.networkKey) {
                    let NASInput = {
                        provider: meta.networkKey,
                        timestamp: currentTime,
                    };
                    if (!this.NAS) {
                        this.NAS = [NASInput];
                    }
                    else {
                        let last = this.NAS[0].provider;
                        if (last !== meta.networkKey) {
                            this.NAS.unshift(NASInput);
                        }
                    }
                }
                //RSE DOES NOT EXIST ON ANY ITEM
                // if (meta.version) {
                //   let versionInput = {
                //     version: meta.version,
                //     timestamp: currentTime,
                //   }
                //   if (!this.version) {
                //     this.version = [versionInput]
                //   } else {
                //     let last = this.version[0].version
                //     if (last !== meta.networkKey) {
                //       this.version.unshift(versionInput)
                //     }
                //   }
                // }
                /** RSE: THIS IS VAGUE USEFUL, IF COMPLETELY UNTYPED   */
                if (reported.error) {
                    let combined = Object.keys(reported.error)
                        .reduce((res, cur) => {
                        if (reported.error[cur] === 1) {
                            res.push(cur);
                        }
                        return res;
                    }, [])
                        .join(', ');
                    let errorInput = {
                        error: combined,
                        startTimestamp: currentTime,
                        state: 'Unresolved',
                    };
                    if (!this.errors) {
                        this.errors = [errorInput];
                    }
                    else {
                        let last = this.errors[0].error;
                        if (last !== combined) {
                            this.errors.unshift(errorInput);
                        }
                    }
                }
                // messageType
                // history
                /** RSE THIS IS NEVER USED -- REMOIVED */
                // let hist = this.history ?? []
                // if (hist.length >= HISTORY_LIMIT) {
                //   hist.splice(HISTORY_LIMIT - 1)
                // }
                // hist.unshift(reported)
                // this.history = hist
                delete this.history;
            }
        };
        this.type = ob.type ?? exports.DeviceHistoryClassName;
        this.history = ob.history?.slice(-HISTORY_LIMIT);
    }
    // appendConfig(data: ConfigHistory) {
    //   if (this.config) {
    //     this.config.push(data);
    //   } else {
    //     this.config = [data];
    //   }
    // }
    /** RSE THERE IS NO TRACE OF ANY USE ANYWHERE  FOR APPEND FAULT */
    /**
     * Make sure the entity is saved!
     * @param error Error of this device
     * @param user User account made this change
     */
    appendFault(error, user) {
        let fault = {
            error,
            startTimestamp: Date.now(),
            state: 'Unresolved',
        };
        if (user) {
            fault = { ...fault, user: user.name };
        }
        if (this.errors) {
            this.errors.push(fault);
        }
        else {
            this.errors = [fault];
        }
    }
    /** RSE THERE IS NO TRACE OF ANY USE ANYWHERE  FOR APPEND VERSION */
    /**
     * Make sure the entity is saved!
     * @param version
     */
    appendVersion(version) {
        let newVersion = {
            version: typeof version === 'string' ? version : version.toString(),
            timestamp: Date.now(),
        };
        if (this.version && this.version.length > 0) {
            // Shouldn't be required, but confirm the last version is different
            if (this.version[this.version.length - 1].version !== newVersion.version) {
                this.version.push(newVersion);
            }
        }
        else {
            this.version = [newVersion];
        }
    }
    /** RSE THERE IS NO TRACE OF ANY USE ANYWHERE  FOR APPEND LOCATION */
    /**
     * Make sure the entity is saved!
     * @param position Position of the new location
     * @param user User making this change
     */
    appendLocation(position, user) {
        let location = {
            position,
            timestamp: Date.now(),
        };
        if (user) {
            location = { ...location, user: user.name, userId: user.id };
        }
        if (this.location) {
            this.location.push(location);
        }
        else {
            this.location = [location];
        }
    }
    /** RSE THERE IS NO TRACE OF ANY USE ANYWHERE  FOR APPEND NETWORK */
    /**
     * Make sure the entity is saved!
     * @param networking Network of where it is now checking in it
     */
    appendNetwork(networking) {
        let network = {
            provider: networking,
            timestamp: Date.now(),
        };
        if (this.NAS && this.NAS.length > 0) {
            // Shouldn't be required, but confirm the last network is different
            if (this.NAS[this.NAS.length - 1].provider.toString() !== networking.toString()) {
                this.NAS.push(network);
            }
        }
        else {
            this.NAS = [network];
        }
    }
    /** RSE THERE IS NO TRACE OF ANY USE ANYWHERE  FOR APPEND ASSOCIATION */
    /**
     * Make sure the entity is saved!
     * Updates the object with the entity.
     * @param data Data of the entity being linked to the device
     * @param user The user doing this action
     * @param link Linking action, default to linking
     */
    appendAssociation(data, user, link = LINK.LINK) {
        // create it
        let association = {
            withType: data.type,
            link,
            name: data.name,
            id: data.pk, // to hyperlink name
            user: user.sk, // sk of user
            timestamp: Date.now(),
        };
        if (this.associations) {
            this.associations.push(association);
        }
        else {
            this.associations = [association];
        }
    }
    /** RSE THERE IS NO TRACE OF ANY USE ANYWHERE  FOR APPEND GENERIC */
    /**
     * Make sure the entity is saved!
     * Generic linking method that may potential match the wrong type
     * Allows slight variations of the format to be saved
     * @param data
     * @param type
     */
    appendGeneric(data, type) {
        if (this[type]) {
            this[type].push(data);
        }
        else {
            this[type] = [data];
        }
    }
    static createForDevice(device) {
        const pk = device.pk;
        const sk = `${device.sk}_${exports.DeviceHistoryClassName}`;
        const id = `${device.id}_${exports.DeviceHistoryClassName}`;
        const name = `${device.name ?? device.sk} History`;
        const type = exports.DeviceHistoryClassName;
        return new DeviceHistory({ pk, sk, id, name, type });
    }
}
exports.DeviceHistory = DeviceHistory;
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Object)
], DeviceHistory.prototype, "update", void 0);
